import script from "./Merch.vue?vue&type=script&setup=true&lang=js"
export * from "./Merch.vue?vue&type=script&setup=true&lang=js"

import "./Merch.vue?vue&type=style&index=0&id=b5005550&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5005550"]])

export default __exports__